import { useNavigate } from "react-router-dom";
import { STATUS_MISSION } from "constants/constants";

export const useDoughnutNavigation = (userScope) => {
  const navigate = useNavigate();

  const navigateWithFilter = (path, filters = null) => {
    const fullPath = `/${userScope}${path}`;
    const navigationOptions = filters
      ? { state: { dashboardFilter: filters } }
      : undefined;

    navigate(fullPath, navigationOptions);
  };

  const sliceNavigationConfig = [
    {
      pattern: /sans fin/,
      path: "/missions",
      filters: { status: STATUS_MISSION.ONE },
    },
    {
      pattern: /fdm réglée/,
      path: "/dashboard/shared/ok",
    },
    {
      pattern: /fdm non réglée/,
      path: "/missions",
      filters: { status: STATUS_MISSION.FDM },
    },
    {
      pattern: /ic réglé/,
      path: "/dashboard/shared/ok",
    },
    {
      pattern: /ic non réglé/,
      path: "/dashboard/shared/ic",
    },
    {
      pattern: /ed réglé/,
      path: "/dashboard/shared/ok",
    },
    {
      pattern: /ed non réglé/,
      path: "/dashboard/shared/ic",
    },
    {
      pattern: /cl non réglé/,
      path: "/dashboard/shared/cl",
    },
    {
      pattern: /cl en cours/,
      path: "/dashboard/shared/cl",
    },
    {
      pattern: /cl/,
      path: "/dashboard/shared/ok",
    },
    {
      pattern: /missions? en cours/,
      path: "/missions",
      filters: { status: [STATUS_MISSION.ONE, STATUS_MISSION.FDM] },
    },
  ];

  const handleSliceClick = (datum) => {
    if (!datum?.label) return;

    const lowerLabel = datum.label.toLowerCase();

    const matchedConfig = sliceNavigationConfig.find((config) =>
      config.pattern.test(lowerLabel)
    );

    if (matchedConfig) {
      navigateWithFilter(matchedConfig.path, matchedConfig.filters);
    }
  };

  return handleSliceClick;
};
